module.exports = __webpack_public_path__ + "static/media/switzerland-flag.8f31650f.png";